import { selectProjectType, useAppSelector } from '@core/core/store'
import { parseDate, parseProjectSize, relativeDateFormatter } from '@core/core/utils'
import type { FC } from 'react'

import { SidebarRow } from '../SidebarRow'
import type { ISidebarBottomInfo } from './types'

const convertDate = (date?: string) =>
  relativeDateFormatter.relativeDate(parseDate(date)) || 'Нет данных'

export const SidebarBottomInfo: FC<ISidebarBottomInfo> = ({ projectData }) => {
  const projectType = useAppSelector(state => selectProjectType(state, projectData.type))
  return (
    <>
      <SidebarRow type="Год" value={projectData.year} />
      <SidebarRow type="Тип" value={projectType} />
      <SidebarRow type="Изменено" value={convertDate(projectData.changedAt)} />
      <SidebarRow type="Создан" value={convertDate(projectData.createdAt)} />
      <SidebarRow type="Создал(а)" value={projectData.createdBy} />
      <SidebarRow type="Размер" value={parseProjectSize(projectData.size)} />
    </>
  )
}
